module.exports = __webpack_public_path__ + "static/media/16.3b57b08f.svg";